import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './modules/auth'
import usersModule from './modules/users'
import customersModule from './modules/customers'
import productDataModule from './modules/productData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authModule,
    users: usersModule,
    customers: customersModule,
    productData: productDataModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js